'use client';

import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, List, ListItem, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';
import { getAosDelay, mergeAos, zoomInAosProps } from '@utils/aosProps';
import cn from './style.module.scss';
export default function EastvaleCommunity(props: MarketingPageComponentProps) {
  const communitySection = props?.locale?.section?.find(
    (section: any) => section.type === 'community' && section.enabled
  );
  if (!communitySection) return null;
  const eastvaleCommunityElementList =
    communitySection?.eastvaleCommunityData ?? [];
  return (
    <Stack component="section" className={cn.eastvaleCommunityWrapper}>
      <Box className={cn.eastvaleCommunityInner}>
        <CommonContainer
          paddingInline={{ xs: '1.25rem', sm: '1.25rem', md: '1.25rem' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.eastvaleCommunityBlock}>
            <Box className={cn.eastvaleCommunityHeading}>
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(communitySection?.eastvaleCommunityHeading)}
              </ParallaxText>
            </Box>
            <List className={cn.eastvaleCommunityList}>
              {eastvaleCommunityElementList.map(
                (feature: any, index: number) => (
                  <ListItem key={index} className={cn.eastvaleCommunityItem}>
                    <Box
                      className={cn.eastvaleCommunityElement}
                      {...mergeAos(
                        zoomInAosProps,
                        getAosDelay(200 + index * 5)
                      )}
                    >
                      <Box className={cn.eastvaleCommunityIcon}>
                        <CustomImage
                          src={feature.icon}
                          alt={feature.alt}
                          width={40}
                          height={40}
                        />
                      </Box>
                      <Box className={cn.eastvaleCommunityContent}>
                        <ParallaxText
                          variant="h4"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(feature.title)}
                        </ParallaxText>
                        <ParallaxText
                          variant="p"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(feature.description)}
                        </ParallaxText>
                      </Box>
                    </Box>
                  </ListItem>
                )
              )}
            </List>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
